/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable quotes */ import React, { useState, useEffect } from "react";
import { Table, Space, Button, Tooltip, Input } from "antd";
import useCustomNavigate from "../../../components/customNavigationHook";
import "./rtoRequestsList.scss";
import { ReactComponent as View_icon } from "../../../assests/images/SVG/view-details.svg";
import API from "../../../api";
import urls from "../../../api/urls";
import moment from "moment";
import search_icon from "../../../assests/images/search-icon.svg";

const RTORequestsList = ({ tabValue }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useCustomNavigate();
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);

  useEffect(() => {
    fetchRTORequests();
  }, [tabValue]);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  const fetchRTORequests = async (p1 = 10, p2 = 0, customParams) => {
    setLoading(true);
    try {
      let queryParams;
      if (customParams) {
        queryParams = customParams;
      } else {
        queryParams = new URLSearchParams({
          page: (p2 + 1).toString(),
          limit: p1.toString(),
          // status: 'RTO'  // You can adjust this status based on your requirements
        });
      }

      const result = await API.Api(
        `${urls.REQUESTED_RTO_LIST}?${queryParams.toString()}`
      ).get();
      const response = result?.response?.data?.data;

      if (response) {
        setTotal(response?.metadata?.total || 0);
        setData(response?.rtoList || []);
      }
    } catch (error) {
      console.error("Error fetching RTO requests:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (record) => {
    navigate(`/shipments-details/${record.awbNumber}`);
  };

  const columns = [
    {
      title: "AWB",
      dataIndex: "awbNumber",
      key: "awbNumber",
      render: (text) => text || "-",
    },
    {
      title: "Requested for RTO On",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => moment(text).format("DD/MM/YYYY hh:mm A") || "-",
    },
    {
      title: "Delivery Attempted On",
      dataIndex: "deliveryAttemptedOn",
      key: "deliveryAttemptedOn",
      render: (text) =>
        text ? moment(text).format("DD/MM/YYYY hh:mm A") : "-",
    },
    {
      title: "DA Name",
      dataIndex: "daName",
      key: "daName",
      render: (text) => text || "-",
    },
    {
      title: "DA Mobile No.",
      dataIndex: "daMobileNo",
      key: "daMobileNo",
      render: (text) => text || "-",
    },
    {
      title: "Customer Mobile No.",
      dataIndex: "customerMobileNumber",
      key: "customerMobileNumber",
      render: (text) => text || "-",
    },
    {
      title: "Seller Mobile No.",
      dataIndex: "sellerMobileNumber",
      key: "sellerMobileNumber",
      render: (text) => text || "-",
    },
    {
      title: "Status",
      dataIndex: "requestStatus",
      key: "requestStatus",
      render: (text) => text || "-",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Tooltip title={"View Details"} placement="bottom">
          <p
            className="pointer"
            style={{ marginTop: "4px", marginBottom: "0" }}
            onClick={() => handleView(record)}
          >
            <View_icon />
          </p>
        </Tooltip>
      ),
    },
  ];
  const handlePageChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);

    const queryParams = new URLSearchParams({
      page: pagination.current.toString(),
      limit: pagination.pageSize.toString(),
      // status: 'RTO'
    });
    fetchRTORequests(pagination.pageSize, pagination.current - 1, queryParams);
  };

  const onSearch = async (e) => {
    const searchQuery = e.target.value;
    if (searchQuery) {
      const queryParams = new URLSearchParams({
        awbNumber: searchQuery,
        // status: 'RTO'
      });
      fetchRTORequests(10, 0, queryParams);
    } else {
      fetchRTORequests();
    }
  };
  return (
    <div className="rto-requests-list master-main-container m-1 p-1">
      <div className="p-1" style={{ display: "flex", justifyContent: "end" }}>
        <Input
          placeholder="Search by AWB Number"
          bordered
          style={{ borderRadius: "5px", height: "40px", width: "465px" }}
          suffix={<img src={search_icon} />}
          onChange={(e) => {
            onSearch(e);
          }}
        />
      </div>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        rowKey="id"
        pagination={{
          pageSize: pageSize,
          total: total,
          itemRender: itemRender,
          current: pageNum == 0 ? +1 : pageNum,
        }}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default RTORequestsList;
